export default __webpack_public_path__ + "static/media/sec1-1.faf9d5dd.svg";